import AdapterEzEditTable from './adapterEzEditTable';

export default AdapterEzEditTable;


// WEBPACK FOOTER //
// ./src/extensions/advancedGrid/advancedGrid.js